import amplitude from 'amplitude-js';
import { config, distributorName } from 'config';
import { getMe } from './local-data-provider';

class AmplitudeService {
  constructor() {
    this.isInit = false;
  }

  init = () => {
    amplitude.getInstance().init(config.amplitudeKey);
    this.isInit = true;
  };

  track = (name, properties = {}, callback) => {
    if (!this.isInit) this.init();
    properties['distributor'] = distributorName() === '國泰優惠' ? '輕麻雲' : distributorName();
    amplitude.getInstance().setUserId(getMe()?.id);
    amplitude.getInstance().logEvent(name, properties, callback);
  };

  //通用
  ads_onClick = id => this.track('廣告_click', { id });

  // Welcome
  tutorial_scroll = page =>
    this.track('tutorial_scroll', {
      slide: page,
    });
  tutorial_pageview = () => this.track('tutorial_pageview');
  tutorial_later_onClick = () => this.track('tutorial_稍後_click');
  tutorial_start_onClick = () => this.track('tutorial_立即開始_click');

  // 登入
  login_pageview = () => this.track('連結帳戶_登入_pageview');
  login_mobile_onClick = () => this.track('連結帳戶_輸入手機_click');
  login_sendOtp_onClick = () => this.track('連結帳戶_傳送驗證碼_click');
  login_otp_onClick = () => this.track('連結帳戶_輸入驗證碼_click');
  login_button_onClick = () => this.track('連結帳戶_登入/註冊_click');

  // 註冊
  register_pageview = () => this.track('連結帳戶_註冊_pageview');
  register_email_onClick = () => this.track('連結帳戶_輸入電子信箱_click');
  register_button_onClick = () => this.track('連結帳戶_完成註冊_click');

  // 路停自動繳
  onStreetParkingAutoPay_pageview = () => this.track('路停自動繳OB_立即啟用自動繳_pageview');
  onStreetParkingAutoPay_start_onClick = () => this.track('路停自動繳OB_立即啟用_click');
  onStreetParkingAutoPay_later_onClick = () => this.track('路停自動繳OB_稍後_click');
  onStreetParkingAutoPay_dialog_onOpen = () => this.track('路停自動繳OB_dialog_open');
  onStreetParkingAutoPay_dialog_enable_onClick = () => this.track('路停自動繳OB_dialog_啟用自動繳_click');
  onStreetParkingAutoPay_dialog_pass_onClick = () => this.track('路停自動繳OB_dialog_先不啟用_click');

  // 加入付款車牌
  addPlateNumber_pageview = () => this.track('路停自動繳OB_加入車牌_pageview');
  addPlateNumber_plateNumber_onClick = () => this.track('路停自動繳OB_輸入車牌_click');
  addPlateNumber_vehicleType_onClick = type => this.track('路停自動繳OB_選擇車種_click', { 車種: type });
  addPlateNumber_button_onClick = ({ plateNumber, type }) =>
    this.track('路停自動繳OB_設定好了_click', {
      車牌: plateNumber,
      車種: type,
    });
  addPlateNumber_later_onClick = () => this.track('路停自動繳OB_稍後輸入車牌_click');
  addplateNumber_rental_dialog_pageview = () => this.track('路停自動繳OB_租賃車提示dialog_pageview');
  addPlateNumber_rental_dialog_confirm_onClick = () => this.track('路停自動繳OB_租賃車提示dialog_知道了_Click');
  activated_confirm_onClick = () => this.track('路停自動繳OB_車牌頁_確定啟用_click');
  activated_dialog_pageview = () => this.track('路停自動繳OB_車牌頁_選擇車牌彈窗_pageview');
  activated_dialog_back_onClick = () => this.track('路停自動繳OB_車牌頁_選擇車牌彈窗_返回_click');

  // 連結付款
  bindCard_pageview = () => this.track('路停自動繳OB_綁定信用卡_pageview');
  bindCard_ccNumber_onClick = () => this.track('路停自動繳OB_輸入卡號_click');
  bindCard_ccExpireDate_onClick = () => this.track('路停自動繳OB_輸入到期日_click');
  bindCard_ccCVC_onClick = () => this.track('路停自動繳OB_輸入CVC_click');
  bindCard_button_onClick = ({ paymentType }) => this.track('路停自動繳OB_開始綁定_click', { paymentType });
  bindCard_later_onClick = () => this.track('路停自動繳OB_稍後綁定_click');
  // npc
  bindNpcPay_switchRedeemUse_onClick = ({ type }) =>
    this.track('路停自動繳OB_付款頁_連結通路 payment_外部點數折抵開關', { type });

  // 提醒查詢路停單
  onStreetParkingAutoPayNotice_pageview = () => this.track('路停自動繳OB_查詢代繳單_pageview');
  onStreetParkingAutoPayNotice_search_onClick = () => this.track('路停自動繳OB_查詢待繳單付款_click');
  onStreetParkingAutoPayNotice_later_onClick = () => this.track('路停自動繳OB_查繳稍後_click');

  // 主頁
  main_pageview = () => this.track('行動錢包_pageview');
  main_login_onClick = () => this.track('行動錢包_未登入_登入麻吉付_click');
  main_set_mochipay_onClick = () => this.track('行動錢包_已登入_設定麻吉付_Click');
  main_setting_onClick = () => this.track('行動錢包_齒輪_click');
  main_ads_onClick = id => this.track('行動錢包_廣告_click', { id });
  main_notification_onClick = id => this.track('行動錢包_異常公告_click', { id });
  main_refueling_onClick = () => this.track('行動錢包_我要加油_click');
  main_parking_onClick = () => this.track('行動錢包_我要停車_click');
  main_onStreetParking_onClick = () => this.track('行動錢包_路停停車_click');
  main_scanpay_onClick = () => this.track('行動錢包_條碼付款_click');
  main_plateNumber_onClick = () => this.track('行動錢包_列表_付款車牌_click');
  main_payment_onClick = () => this.track('行動錢包_列表_付款方式_click');
  main_receipt_onClick = () => this.track('行動錢包_列表_發票設定_click');
  main_orders_onClick = () => this.track('行動錢包_列表_消費紀錄_click');
  main_promotions_onClick = () => this.track('行動錢包_列表_付款優惠_click');
  main_shortcut_onClick = () => this.track('行動錢包_列表_儲存網頁 App 捷徑_click');
  main_contact_onClick = () => this.track('行動錢包_列表_聯繫客服_click');
  main_parking_navigation_onClick = () => this.track('行動錢包_停車中_導航_click');
  main_parking_help_onClick = () => this.track('行動錢包_停車中_幫助_click');
  main_parking_help_paid_onClick = () => this.track('停車中_幫助_我已繳費離場_click');
  main_parking_help_notParking_onClick = () => this.track('停車中_幫助_我沒有去停車_click');
  main_parking_help_more_onClick = () => this.track('停車中_幫助_進一步協助_click');
  main_parking_help_cancel_onClick = () => this.track('停車中_幫助_取消_click');

  // 設定頁
  setting_pageview = () => this.track('會員設定頁_pageview');
  setting_profile_onClick = () => this.track('會員設定頁_個人資料_click');
  setting_terms_onClick = () => this.track('會員設定頁_麻吉付服務條款_click');
  setting_logout_onClick = () => this.track('會員設定頁_登出_click');

  // 捷徑教學頁
  shortcut_pageview = () => this.track('捷徑教學頁_pageview');
  shortcut_back_onClick = () => this.track('捷徑教學頁_返回_Click');
  shortcut_iphone_onClick = () => this.track('捷徑教學頁_iPhone_Click');
  shortcut_android_onClick = () => this.track('捷徑教學頁_Android_Click');

  // 加油要求
  refueling_request_pageview = () => this.track('加油授權_加油視窗_pageview');
  accept_refueling_request = () => this.track('加油授權_同意付款_Click');
  cancel_refueling_request = () => this.track('加油授權_關閉視窗_Click');

  // 路停自動繳
  onStreetParking_enable_onClick = () => this.track('開啟路停頁_開啟_Click');
  onStreetParking_disable_onClick = () => this.track('開啟路停頁_關閉_Click');
  onStreetParking_notice_inquire_onClick = () => this.track('開啟路停頁_提醒視窗_前往查詢繳_Click');
  onStreetParking_notice_inquire_onClose = () => this.track('開啟路停頁_提醒視窗_關閉_Click');
  onStreetParking_inquire_onClick = () => this.track('開啟路停頁_查詢繳費_Click');
  onStreetParking_inquire_complete_onClick = () => this.track('開啟路停頁_查詢繳費_完成_Click');
  onStreetParking_help_onClick = () => this.track('開啟路停頁_常見問題_Click');

  // 車牌設定頁
  plateNumber_add_onClick = () => this.track('車牌頁_新增_Click');
  plateNumber_add_plate_onClick = () => this.track('車牌頁_新增_輸入車牌_Click');
  plateNumber_add_type_onClick = () => this.track('車牌頁_新增_選擇車種_Click');
  plateNumber_add_complete_onClick = () => this.track('車牌頁_新增_設定好了_Click');
  plateNumber_plate_onClick = () => this.track('車牌頁_車牌_Click');
  plateNumber_activate_onClick = () => this.track('車牌頁_啟用_Click');
  plateNumber_window_rebind_onClick = () => this.track('車牌頁_編輯視窗_重新綁定_Click');
  plateNumber_window_edit_onClick = () => this.track('車牌頁_編輯視窗_修改車牌_Click');
  plateNumber_window_delete_onClick = () => this.track('車牌頁_編輯視窗_刪除車牌_Click');
  plateNumber_window_cancel_onClick = () => this.track('車牌頁_編輯視窗_取消_Click');
  plateNumber_window_deactivate_onClick = () => this.track('車牌頁_編輯視窗_不啟用車牌_Click');
  plateNumber_edit_plate_onClick = () => this.track('車牌頁_修改_修改車牌_Click');
  plateNumber_edit_type_onClick = () => this.track('車牌頁_修改_選擇車種_Click');
  plateNumber_edit_complete_onClick = () => this.track('車牌頁_修改_設定好了_Click');
  plateNumber_rental_dialog_pageview = () => this.track('車牌頁_租賃車提示dialog_pageview');
  plateNumber_rental_dialog_confirm_onClick = () => this.track('車牌頁_租賃車提示dialog_知道了_Click');
  plateNumber_cross_dist_dialog_pageview = () => this.track('車牌頁_尚綁定在其他服務dialog_pageview');
  plateNumber_cross_dist_dialog_confirm_onClick = () => this.track('車牌頁_尚綁定在其他服務dialog_知道了_Click');

  // 付款頁
  payment_addCard_onClick = () => this.track('付款頁_新增_Click');
  payment_addCard_cardNumber_onClick = () => this.track('付款頁_新增_卡號_Click');
  payment_addCard_expireDate_onClick = () => this.track('付款頁_新增_有效期限_Click');
  payment_addCard_cvc_onClick = () => this.track('付款頁_新增_安全碼_Click');
  payment_addCard_confirm_onClick = () => this.track('付款頁_新增_設定好了_Click');
  payment_setting_reset_onClick = () => this.track('付款頁_齒輪_重新設定_Click');
  payment_setting_delete_onClick = () => this.track('付款頁_齒輪_刪除_Click');
  payment_setting_cancel_onClick = () => this.track('付款頁_齒輪_取消_Click');
  payment_setting_delete_confirm_onClick = () => this.track('付款頁_齒輪_刪除_確認_Click');
  payment_setting_delete_cancel_onClick = () => this.track('付款頁_齒輪_刪除_取消_Click');
  payment_bindCard_onClick = () => this.track('付款頁_綁定中油pay_Click');
  payment_bindCard_onCancel = () => this.track('付款頁_綁定中油pay_解除綁定_Click'); //deprecate
  payment_bindCard_confirm_onClick = () => this.track('付款頁_綁定中油pay_確認綁定_Click'); // deprecate
  payment_bindCard_cancel_onClick = () => this.track('付款頁_綁定中油pay_取消_Click');

  payment_linkCard_onClick = cardType => this.track('付款頁_連結通路 payment_Click', { cardType });
  payment_switchRedeemUse_onClick = ({ type }) => this.track('付款頁_連結通路 payment_外部點數折抵開關', { type });
  payment_linkCard_confirm_onClick = () => this.track('付款頁_連結通路 payment_確認連結_Click');
  payment_linkCard_dialog_unlink_onClick = () => this.track('付款頁_連結通路 payment_彈窗_斷連_Click');
  payment_linkCard_dialog_cancel_onClick = () => this.track('付款頁_連結通路 payment_彈窗_取消_Click');

  // 教學頁
  serviceInstruction_pageview = name => this.track(`${name}說明頁_pageview`);
  serviceInstruction_playVideo_onClick = name => this.track(`${name}說明頁_播放影片_Click`);
  serviceInstruction_tutorial_swipe = (name, slide, type) => this.track(`${name}說明頁_教學`, { slide, 類型: type });
  serviceInstruction_plate_onClick = name => this.track(`${name}說明頁_車牌設定_Click`);
  serviceInstruction_pass_onClick = name => this.track(`${name}說明頁_快速通設定_Click`);
  serviceInstruction_payment_onClick = name => this.track(`${name}說明頁_付款設定_Click`);
  serviceInstruction_support_onClick = (name, poi) => this.track(`${name}說明頁_支援${poi}_Click`);
  serviceInstruction_refueling_selector_onClick = type => this.track(`加油說明頁_加油站類型_Click`, { 類型: type });
  serviceInstruction_refueling_hint_onClick = () => this.track(`加油說明頁_支援付款方式_Click`);
  serviceInstruction_refueling_hint_dialog_pageview = () => this.track(`加油說明頁_支援付款方式 dialog_pageview`);

  // 底部 navbar
  tab_main_onClick = () => this.track('Tab_行動錢包_Click');
  tab_maps_onClick = () => this.track('Tab_支援場站_Click');
  tab_orders_onClick = () => this.track('Tab_消費紀錄_Click');
  tab_coins_onClick = () => this.track('Tab_行車幣_Click');

  //  行車幣頁
  coins_pageview = () => this.track('行車幣_pageview');
  coins_enabled_onClick = () => this.track('行車幣_獲得_Click');
  coins_enabled_pageview = () => this.track('行車幣_獲得_pageview');
  coins_disabled_onClick = () => this.track('行車幣_已使用_Click');
  coins_disabled_pageview = () => this.track('行車幣_已使用_pageview');
  coins_help_onClick = () => this.track('行車幣_幫助_Click');

  // 消費紀錄
  orders_tab_onClick = ({ transactionType }) => this.track('消費紀錄頁_交易類型_頁籤', { transactionType });

  // 發票設定
  receipt_pageview = () => this.track('發票設定頁_pageview');
  receipt_select_onClick = type => this.track('發票設定頁_載具設定_Click', { 類型: type });
  receipt_save_onClick = () => this.track('發票設定頁_儲存_Click');
  receipt_download_onClick = () => this.track('發票設定頁_下載報表明細_Click');
  receipt_download_dialog_forward = () => this.track('發票設定頁_報表明細 dialog_前往');
  receipt_download_dialog_cancel = () => this.track('發票設定頁_報表明細 dialog_返回');

  // 條碼付款
  scanpay_pageview = () => this.track('條碼付款頁_pageview');
  scanpay_support_onClick = () => this.track('條碼付款頁_支援場站_Click');
  scanpay_receipt_onClick = () => this.track('條碼付款頁_發票更改_Click');
  scanpay_receipt_toggle_onClick = state => this.track('條碼付款頁_發票顯示切換_Click', { 狀態: state });
  scanpay_refresh_onClick = () => this.track('條碼付款頁_重新產出條碼_Click');
  scanpay_dialog_pageview = type => this.track('條碼付款頁_提示dialog_pageview', { 類型: type });
  scanpay_success_pageview = (poi, amount) => this.track('條碼付款頁_繳費成功_pageview', { 場站: poi, 金額: amount });
}

export default new AmplitudeService();
